import {PatFormaTombamentoModel} from '@/models/patrimonio/patformatombamento/patformatombamento.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class PatFormaTombamentoService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<PatFormaTombamentoModel>>> {
  return api.post <DataSource <PatFormaTombamentoModel>>('/PatFormaTombamento/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(patFormaTombamento: PatFormaTombamentoModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/PatFormaTombamento', patFormaTombamento);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/PatFormaTombamento/' + id);
 }

 atualizar(patFormaTombamento: PatFormaTombamentoModel): Promise<AxiosResponse> {
  return api.put('/PatFormaTombamento', patFormaTombamento);
 }

 async get(id: number): Promise<PatFormaTombamentoModel> {
  const result = await api.get<PatFormaTombamentoModel>(`/PatFormaTombamento/${id.toString()}`);
  return result.data;
 }

 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/PatFormaTombamento/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new PatFormaTombamentoService();
